import axios from "axios";
import {apiUrl} from "../../App";

export async function deleteUserUseCase(id: string) {
    return await axios.delete(`${apiUrl}/admin/users/${id}`, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
    });
}